import { mode } from '@chakra-ui/theme-tools';

const baseStyle = props => ({
  borderRadius: 'md',
  boxShadow: 'base',
  bg: mode('white.100', 'dark.100')(props),
  '*::-webkit-scrollbar-thumb': {
    borderColor: mode('white.100', 'dark.100')(props),
  },
});

const sizes = {
  sm: {
    padding: 4,
  },
  md: {
    padding: 6,
  },
};

const variants = {
  unstyled: {
    boxShadow: 'none',
    padding: 0,
  },
  flex: {
    padding: 0,
    display: 'flex',
    flexGrow: 1,
  },
  inner: {
    boxShadow: 'none',
    bg: 'transparent',
    borderRadius: 0,
    padding: 0,
    gridRowGap: 2,
  },
  blueLight: props => ({
    borderRadius: 'sm',
    borderWidth: 2,
    bg: mode('blueLight', 'dark.100')(props),
  }),
};

const defaultProps = {
  size: 'md',
};

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
